import { render, staticRenderFns } from "./GiftCardFooter.vue?vue&type=template&id=3a8e10a8&scoped=true"
import script from "./GiftCardFooter.vue?vue&type=script&lang=ts"
export * from "./GiftCardFooter.vue?vue&type=script&lang=ts"
import style0 from "./GiftCardFooter.vue?vue&type=style&index=0&id=3a8e10a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e10a8",
  null
  
)

export default component.exports